import { ArrowLeft } from 'lucide-react';
import { whatsappTheme } from './whatsappTheme';

const { colors } = whatsappTheme;

/**
 * A phone-shaped frame around a WhatsApp chat: green header with the contact name and a small
 * "business account" line, the wallpaper as the body, and an inert message bar at the bottom.
 * @param {{title: string, subtitle?: string, children: import('react').ReactNode}} props
 */
const PhoneFrame = ({ title, subtitle = 'business account', children }) => (
  <div
    className="mx-auto w-full max-w-[340px] overflow-hidden rounded-[2rem] border-[8px] shadow-lg"
    style={{ borderColor: colors.frame, fontFamily: whatsappTheme.fontFamily }}
  >
    <header
      className="flex items-center gap-2 px-3 py-2"
      style={{ backgroundColor: colors.header, color: colors.headerText }}
    >
      <ArrowLeft aria-hidden="true" className="h-5 w-5 shrink-0" />
      <span
        aria-hidden="true"
        className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-base font-medium"
        style={{ backgroundColor: colors.avatar, color: colors.textSecondary }}
      >
        {title.trim().charAt(0).toUpperCase()}
      </span>
      <div className="min-w-0 leading-tight">
        <div className="truncate text-base font-medium">{title}</div>
        <div className="truncate text-[13px]" style={{ color: colors.headerSubtext }}>
          {subtitle}
        </div>
      </div>
    </header>
    <div data-testid="wallpaper" className="min-h-[260px] px-3 py-3" style={{ backgroundColor: colors.wallpaper }}>
      {children}
    </div>
    <div aria-hidden="true" className="px-2 py-2" style={{ backgroundColor: colors.panel }}>
      <div className="rounded-full bg-white px-4 py-2 text-[15px]" style={{ color: colors.textSecondary }}>
        Message
      </div>
    </div>
  </div>
);

export default PhoneFrame;
